import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-73248fa7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "season-game-score-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "layout-inner -top-and-bottom"
}
const _hoisted_3 = {
  key: 1,
  class: "season-game-score-content"
}
const _hoisted_4 = { class: "scoreboard-menu" }
const _hoisted_5 = { class: "return" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" 戻る ")
const _hoisted_7 = { class: "period-operation" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 前半キックオフ ")
const _hoisted_10 = [
  _hoisted_8,
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch-slash icon" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" 前半終了 ")
const _hoisted_13 = [
  _hoisted_11,
  _hoisted_12
]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch icon" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 後半キックオフ ")
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch-slash icon" }, null, -1))
const _hoisted_18 = /*#__PURE__*/_createTextVNode(" 後半終了 ")
const _hoisted_19 = [
  _hoisted_17,
  _hoisted_18
]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch icon" }, null, -1))
const _hoisted_21 = /*#__PURE__*/_createTextVNode(" 延長前半キックオフ ")
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch-slash icon" }, null, -1))
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" 延長前半終了 ")
const _hoisted_25 = [
  _hoisted_23,
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch icon" }, null, -1))
const _hoisted_27 = /*#__PURE__*/_createTextVNode(" 延長後半キックオフ ")
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch-slash icon" }, null, -1))
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" 延長後半終了 ")
const _hoisted_31 = [
  _hoisted_29,
  _hoisted_30
]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-crosshair" }, null, -1))
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" PKスタート ")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uil uil-stopwatch-slash icon" }, null, -1))
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" 試合終了 ")
const _hoisted_37 = [
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "count-timer" }
const _hoisted_39 = { class: "time" }
const _hoisted_40 = { class: "score-number-block" }
const _hoisted_41 = ["data-is-active"]
const _hoisted_42 = { class: "score" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "前半", -1))
const _hoisted_44 = { class: "score" }
const _hoisted_45 = ["data-is-active"]
const _hoisted_46 = { class: "score" }
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "後半", -1))
const _hoisted_48 = { class: "score" }
const _hoisted_49 = ["data-is-active"]
const _hoisted_50 = { class: "score" }
const _hoisted_51 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "延長前半", -1))
const _hoisted_52 = { class: "score" }
const _hoisted_53 = ["data-is-active"]
const _hoisted_54 = { class: "score" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "延長後半", -1))
const _hoisted_56 = { class: "score" }
const _hoisted_57 = ["data-is-active"]
const _hoisted_58 = { class: "score" }
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "label" }, "PK", -1))
const _hoisted_60 = { class: "score" }
const _hoisted_61 = { class: "score-team-summary" }
const _hoisted_62 = ["data-selected"]
const _hoisted_63 = { class: "name" }
const _hoisted_64 = { class: "score" }
const _hoisted_65 = ["data-selected"]
const _hoisted_66 = { class: "score" }
const _hoisted_67 = { class: "name" }
const _hoisted_68 = { class: "score-team-container" }
const _hoisted_69 = { class: "score-team-detail" }
const _hoisted_70 = { class: "score-team-detail" }
const _hoisted_71 = /*#__PURE__*/_createTextVNode(" 試合情報に戻る ")
const _hoisted_72 = { class: "global-empty-text" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode("試合情報")
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" で対戦チームを選択してください。 ")
const _hoisted_75 = {
  key: 2,
  class: "season-game-score-content"
}
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 試合情報に戻る ")
const _hoisted_77 = { class: "global-empty-text" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" この試合は終了しています。")
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_80 = /*#__PURE__*/_createTextVNode(" スコア内容を変更したい場合は、 ")
const _hoisted_81 = /*#__PURE__*/_createTextVNode("試合の流れ")
const _hoisted_82 = /*#__PURE__*/_createTextVNode(" から変更してください。 ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GameStartModal = _resolveComponent("GameStartModal")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ScoreBoard = _resolveComponent("ScoreBoard")!
  const _component_BaseDialog = _resolveComponent("BaseDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.game.data != undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_ctx.game.data.status === 0 && (_ctx.game.data.home && _ctx.game.data.away))
              ? (_openBlock(), _createBlock(_component_GameStartModal, {
                  key: 0,
                  game: _ctx.game.data,
                  onOnClickStartButton: _ctx.handleTimer
                }, null, 8, ["game", "onOnClickStartButton"]))
              : _createCommentVNode("", true),
            (_ctx.game.data.status === 0 || _ctx.game.data.status === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_ctx.game.data.home && _ctx.game.data.away)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            _createVNode(_component_router_link, {
                              class: "global-return-link",
                              to: {
                  name: 'seasonGameDetail',
                  params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
                  query: { group: _ctx.game.data.group_id } }
                            }, {
                              default: _withCtx(() => [
                                _hoisted_6
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ]),
                          _createElementVNode("div", _hoisted_7, [
                            (_ctx.timer.periodStatus === 0)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 0,
                                  type: "button",
                                  class: "period-button",
                                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.handleTimer(1, 'start')))
                                }, _hoisted_10))
                              : (_ctx.timer.periodStatus === 1 && _ctx.timer.isCounting)
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 1,
                                    type: "button",
                                    class: "period-button",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleTimer(1, 'end')))
                                  }, _hoisted_13))
                                : (_ctx.timer.periodStatus === 1 && !_ctx.timer.isCounting)
                                  ? (_openBlock(), _createElementBlock("button", {
                                      key: 2,
                                      type: "button",
                                      class: "period-button",
                                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleTimer(2, 'start')))
                                    }, _hoisted_16))
                                  : (_ctx.timer.periodStatus === 2 && _ctx.timer.isCounting)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 3,
                                        type: "button",
                                        class: "period-button",
                                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleTimer(2, 'end')))
                                      }, _hoisted_19))
                                    : (_ctx.timer.periodStatus === 2 && !_ctx.timer.isCounting)
                                      ? (_openBlock(), _createElementBlock("button", {
                                          key: 4,
                                          type: "button",
                                          class: "period-button",
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleTimer(3, 'start')))
                                        }, _hoisted_22))
                                      : (_ctx.timer.periodStatus === 3 && _ctx.timer.isCounting)
                                        ? (_openBlock(), _createElementBlock("button", {
                                            key: 5,
                                            type: "button",
                                            class: "period-button",
                                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleTimer(3, 'end')))
                                          }, _hoisted_25))
                                        : (_ctx.timer.periodStatus === 3 && !_ctx.timer.isCounting)
                                          ? (_openBlock(), _createElementBlock("button", {
                                              key: 6,
                                              type: "button",
                                              class: "period-button",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleTimer(4, 'start')))
                                            }, _hoisted_28))
                                          : (_ctx.timer.periodStatus === 4 && _ctx.timer.isCounting)
                                            ? (_openBlock(), _createElementBlock("button", {
                                                key: 7,
                                                type: "button",
                                                class: "period-button",
                                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleTimer(4, 'end')))
                                              }, _hoisted_31))
                                            : _createCommentVNode("", true),
                            ((_ctx.timer.periodStatus === 2 || _ctx.timer.periodStatus === 4) && !_ctx.timer.isCounting)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 8,
                                  type: "button",
                                  class: "period-button",
                                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.handleTimer(5, 'pk')))
                                }, _hoisted_34))
                              : _createCommentVNode("", true),
                            ((_ctx.timer.periodStatus === 2 || _ctx.timer.periodStatus === 4 || _ctx.timer.periodStatus === 5) && !_ctx.timer.isCounting)
                              ? (_openBlock(), _createElementBlock("button", {
                                  key: 9,
                                  type: "button",
                                  class: "period-button",
                                  onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.openGameDialogEnd()))
                                }, _hoisted_37))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("p", _hoisted_39, _toDisplayString(_ctx.timer.stringTime.currentPeriod), 1)
                        ]),
                        _createElementVNode("div", _hoisted_40, [
                          _createElementVNode("div", {
                            class: "score-number-unit",
                            "data-is-active": _ctx.timer.periodStatus === 1
                          }, [
                            _createElementVNode("p", _hoisted_42, _toDisplayString(_ctx.game.data.option.home_1st_score || 0), 1),
                            _hoisted_43,
                            _createElementVNode("p", _hoisted_44, _toDisplayString(_ctx.game.data.option.away_1st_score || 0), 1)
                          ], 8, _hoisted_41),
                          _createElementVNode("div", {
                            class: "score-number-unit",
                            "data-is-active": _ctx.timer.periodStatus === 2
                          }, [
                            _createElementVNode("p", _hoisted_46, _toDisplayString(_ctx.game.data.option.home_2nd_score || 0), 1),
                            _hoisted_47,
                            _createElementVNode("p", _hoisted_48, _toDisplayString(_ctx.game.data.option.away_2nd_score || 0), 1)
                          ], 8, _hoisted_45),
                          _createElementVNode("div", {
                            class: "score-number-unit",
                            "data-is-active": _ctx.timer.periodStatus === 3
                          }, [
                            _createElementVNode("p", _hoisted_50, _toDisplayString(_ctx.game.data.option.home_ex_1st_score || 0), 1),
                            _hoisted_51,
                            _createElementVNode("p", _hoisted_52, _toDisplayString(_ctx.game.data.option.away_ex_1st_score || 0), 1)
                          ], 8, _hoisted_49),
                          _createElementVNode("div", {
                            class: "score-number-unit",
                            "data-is-active": _ctx.timer.periodStatus === 4
                          }, [
                            _createElementVNode("p", _hoisted_54, _toDisplayString(_ctx.game.data.option.home_ex_2nd_score || 0), 1),
                            _hoisted_55,
                            _createElementVNode("p", _hoisted_56, _toDisplayString(_ctx.game.data.option.away_ex_2nd_score || 0), 1)
                          ], 8, _hoisted_53),
                          _createElementVNode("div", {
                            class: "score-number-unit",
                            "data-is-active": _ctx.timer.periodStatus === 5
                          }, [
                            _createElementVNode("p", _hoisted_58, _toDisplayString(_ctx.game.data.option.home_pk_score || 0), 1),
                            _hoisted_59,
                            _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.game.data.option.away_pk_score || 0), 1)
                          ], 8, _hoisted_57)
                        ]),
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "team-tab-button",
                            "data-selected": _ctx.scoreTab.id === 'home',
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.changeScoreTab('home')))
                          }, [
                            _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.game.data.home.team_name) + " " + _toDisplayString(_ctx.game.data.home.division), 1),
                            _createElementVNode("p", _hoisted_64, _toDisplayString(_ctx.homeTotalScore), 1)
                          ], 8, _hoisted_62),
                          _createElementVNode("button", {
                            type: "button",
                            class: "team-tab-button",
                            "data-selected": _ctx.scoreTab.id === 'away',
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.changeScoreTab('away')))
                          }, [
                            _createElementVNode("p", _hoisted_66, _toDisplayString(_ctx.awayTotalScore), 1),
                            _createElementVNode("p", _hoisted_67, _toDisplayString(_ctx.game.data.away.team_name) + " " + _toDisplayString(_ctx.game.data.away.division), 1)
                          ], 8, _hoisted_65)
                        ]),
                        _createElementVNode("div", _hoisted_68, [
                          _withDirectives(_createElementVNode("div", _hoisted_69, [
                            _createVNode(_component_ScoreBoard, {
                              teamType: "home",
                              game: _ctx.game.data,
                              events: _ctx.events.home,
                              rosters: _ctx.rosters.home,
                              onOnClickEventButton: _ctx.addGameEvent,
                              onOnChangeEvent: _ctx.updateGameEvent,
                              onOnClickDeleteButton: _ctx.openEventDialogDelete
                            }, null, 8, ["game", "events", "rosters", "onOnClickEventButton", "onOnChangeEvent", "onOnClickDeleteButton"])
                          ], 512), [
                            [_vShow, !_ctx.mediaQuery.isMobile || _ctx.scoreTab.id === 'home']
                          ]),
                          _withDirectives(_createElementVNode("div", _hoisted_70, [
                            _createVNode(_component_ScoreBoard, {
                              teamType: "away",
                              game: _ctx.game.data,
                              events: _ctx.events.away,
                              rosters: _ctx.rosters.away,
                              onOnClickEventButton: _ctx.addGameEvent,
                              onOnChangeEvent: _ctx.updateGameEvent,
                              onOnClickDeleteButton: _ctx.openEventDialogDelete
                            }, null, 8, ["game", "events", "rosters", "onOnClickEventButton", "onOnChangeEvent", "onOnClickDeleteButton"])
                          ], 512), [
                            [_vShow, !_ctx.mediaQuery.isMobile || _ctx.scoreTab.id === 'away']
                          ])
                        ])
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createVNode(_component_router_link, {
                          class: "global-return-link",
                          to: {
              name: 'seasonGameDetail',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
              query: { group: _ctx.game.data.group_id } }
                        }, {
                          default: _withCtx(() => [
                            _hoisted_71
                          ]),
                          _: 1
                        }, 8, ["to"]),
                        _createElementVNode("p", _hoisted_72, [
                          _createVNode(_component_router_link, {
                            to: {
                name: 'seasonGameDetail',
                params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
                query: { group: _ctx.game.data.group_id } }
                          }, {
                            default: _withCtx(() => [
                              _hoisted_73
                            ]),
                            _: 1
                          }, 8, ["to"]),
                          _hoisted_74
                        ])
                      ], 64))
                ]))
              : (_ctx.game.data.status === 2)
                ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                    _createVNode(_component_router_link, {
                      class: "global-return-link",
                      to: {
            name: 'seasonGameDetail',
            params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
            query: { group: _ctx.game.data.group_id } }
                    }, {
                      default: _withCtx(() => [
                        _hoisted_76
                      ]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("p", _hoisted_77, [
                      _hoisted_78,
                      _hoisted_79,
                      _hoisted_80,
                      _createVNode(_component_router_link, {
                        to: {
              name: 'seasonGameScore',
              params: { topic_id: _ctx.$route.params.topic_id, season_id: _ctx.$route.params.season_id, game_id: _ctx.$route.params.game_id },
              query: { group: _ctx.game.data.group_id } }
                      }, {
                        default: _withCtx(() => [
                          _hoisted_81
                        ]),
                        _: 1
                      }, 8, ["to"]),
                      _hoisted_82
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.gameDialogEnd.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 0,
          dialog: _ctx.gameDialogEnd,
          onCloseDialog: _ctx.closeGameDialogEnd,
          onOnConfirm: _ctx.onClickGameEnd
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true),
    (_ctx.eventDialogDelete.isOpen)
      ? (_openBlock(), _createBlock(_component_BaseDialog, {
          key: 1,
          dialog: _ctx.eventDialogDelete,
          onCloseDialog: _ctx.closeEventDialogDelete,
          onOnConfirm: _ctx.deleteGameEvent
        }, null, 8, ["dialog", "onCloseDialog", "onOnConfirm"]))
      : _createCommentVNode("", true)
  ], 64))
}